var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiInputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "../styles";
import { Text } from "../text";
import clsx from "../utils/clsx";
export var InputAdornmentComponentName = "CosmosInputAdornment";
export var useInputAdornmentStyles = makeStyles(function (theme) { return ({
    alignTop: {
        alignSelf: "flex-start",
        marginTop: theme.spacing(2.5),
    },
}); }, { name: InputAdornmentComponentName });
export var InputAdornment = React.forwardRef(function (props, ref) {
    var classes = useInputAdornmentStyles(props);
    var _a = props.align, align = _a === void 0 ? "center" : _a, className = props.className, children = props.children, disableTypography = props.disableTypography, 
    // remove to prevent passing through to the root
    propClasses = props.classes, adornmentProps = __rest(props, ["align", "className", "children", "disableTypography", "classes"]);
    return (React.createElement(MuiInputAdornment, __assign({ ref: ref, className: clsx(align === "top" && classes.alignTop, className), disableTypography: true }, adornmentProps), typeof children === "string" && !disableTypography ? (React.createElement(Text, { color: "textSecondary", variant: "body2" }, children)) : (children)));
});
